const initialState = {
  productSalesPrice: [],
  products: [],
  categories: [],
  productList: [],
};

function ProductSalesPriceReducer(state = initialState, action) {
  if (action.type === "PRODUCT_SALESPRICE_LIST") {
    var productDetails = {
      ...state,
      productSalesPrice: action.payload,
    };
    return productDetails;
  }
  if (action.type === "PRODUCT_LIST") {
    var productDetails = {
      ...state,
      products: action.payload,
    };
    return productDetails;
  }
  if (action.type === "PRODUCT_DROPDOWN_LIST") {
    var productDetails = {
      ...state,
      productList: action.payload,
    };
    return productDetails;
  }

  if (action.type === "PRODUCT_CATEGORY_DROPDOWN_LIST") {
    var productDetails = {
      ...state,
      categories: action.payload,
    };
    return productDetails;
  }

  return state;
}

export default ProductSalesPriceReducer;
